import styled from 'styled-components';
import AntAlert from 'antd/lib/alert';

const Alert = styled(AntAlert)`
	text-align: center;
`;
export default Alert;
